import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { Location, Appearance } from '@angular-material-extensions/google-maps-autocomplete';

import { take } from 'rxjs/operators';

import { IAddress } from 'src/app/interfaces/address';
import { JourneyService } from 'src/app/services/journey.service';

declare var jQuery: any;

@Component({
  selector: 'app-journey-selection',
  templateUrl: './journey-selection.component.html',
  styleUrls: ['./journey-selection.component.scss']
})
export class JourneySelectionComponent implements OnInit {
  @Input() setMap: Function;
  @Input() sameLocation: boolean;
  @ViewChild('addressOrigin', {static: false}) addressOrigin;
  @ViewChild('addressDestination', {static: false}) addressDestination;
  public address: IAddress = {
    origin: null,
    loadingOrigin: false,
    destination: null,
    loadingDestination: false
  };
  public appearance = Appearance;
  public customOrigin: string;
  public customDestination: string;

  constructor(
    private journeyService: JourneyService
  ) { }

  ngOnInit() {
    const origin = jQuery('#autocompleteOrigin .mat-form-field-autofill-control');
    const dest = jQuery('#autocompleteDestination .mat-form-field-autofill-control');

    origin.blur(event => {
      this.onBlur(event, true);
    });
    dest.blur(event => {
      this.onBlur(event, false);
    });
  }

  getCurrentOrigin(event) {
    event.preventDefault();
    this.address.loadingOrigin = true;
    this.journeyService.getCurrentOrigin().pipe(take(1)).subscribe(res => {
      this.address.origin = res.address;
      this.address.loadingOrigin = false;
      this.onOriginSelected(res);
      this.journeyService.detectChanges();
    });
  }

  getCurrentDestination(event) {
    event.preventDefault();
    this.address.loadingDestination = true;
    this.journeyService.getCurrentDestination().pipe(take(1)).subscribe(res => {
      this.address.destination = res.address;
      this.address.loadingDestination = false;
      this.onDestinationSelected(res);
      this.journeyService.detectChanges();
    });
  }

  onBlur(event, origin) {
    if (origin) {
      this.addressDestination.searchElementRef.nativeElement.focus();
    } else {
      this.addressDestination.searchElementRef.nativeElement.blur();
    }
    google.maps.event.trigger(event.target, 'keydown', {
      keyCode: 40,
    });
  }

  onOriginSelected(location: Location) {
    this.journeyService.selectOrigin(location).pipe(take(1)).subscribe(
      () => this.setMap());
  }

  onDestinationSelected(location: Location) {
    this.journeyService.selectDestination(location).pipe(take(1)).subscribe(
      () => this.setMap());
  }

  onOriginChange(event) {
    this.customOrigin = event.srcElement.value;
  }

  onDestinationChange(event) {
    this.customDestination = event.srcElement.value;
  }

  clearOrigin() {
    this.addressOrigin.address = '';
    this.address.origin = '';
    this.journeyService.detectChanges();
  }

  clearDestination() {
    this.addressDestination.address = '';
    this.address.destination = '';
    this.journeyService.detectChanges();
  }
}
